<template>
  <div class="h-full w-full z-50 bg-white/60 flex items-center justify-center flex-col">
    <div
      class="w-10 h-10 min-w-10 min-h-10 rounded-full border-8 border-white border-t-blue-cumulus-200-active border-r-blue-cumulus-200-active animate-spin"
    ></div>
    <p role="alert" class="pt-2">Merci de patienter</p>
  </div>
</template>

<script setup lang="ts"></script>
